module.exports = __webpack_public_path__ + "media/homepage/internships-8e4ed957.webp";